module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "70%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("5")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline2",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Moscow, Russia")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("T")])])])]), _vm._v("he day after his date with Kate, Michael Waller entered the passport control area of the Sheremetyevo airport. He reached into his carry-on bag and removed a Russian passport, then he got in the line marked for Russian citizens. It was only minutely shorter than the massive, slow-moving line for foreigners. Some things about Russia would never change.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Michael lifted and dropped his shoulders to release the muscle tension and rolled his neck to try to shake away the headache he felt coming. He simply wasn’t the traveler he used to be. Rarely had he noticed his age all these years crisscrossing continents, but now he felt all of his fifty-five years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He thought then of Kate. God, how unlikely that he should be thinking of her. That he should be thinking of any woman. He’d learned from his divorce that his life did not lend itself to marriage. While secrecy was everything in his business, he simply couldn’t stomach it in a romantic relationship. It made everything feel false, even the parts that were true. And yet now he’d found himself here, easing out of his business. He was pulling away, forcing the Trust to make him one of the outsiders, one of the support staff.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This mission to Russia would hopefully be his last. Thank God. Because age made it harder to stomach the missions, too. Or maybe it wasn’t age. Maybe it was the Trust’s recent descent toward the ruthless and the careless. That wasn’t how they used to operate. Luckily—if you could call it that—his mission in Moscow was absolutely necessary for the good of the organization, and most importantly for the good of the United States. And so he would do his job, no matter how distasteful, and then he would go home, and he would try to start living a more normal existence. And he would call Kate. Because if he was no longer playing the same role he used to, there might be room in his life for a partner. And he might have found her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He moved forward in the line. He would be next to give his documentation to the agent. A flicker of anxiety hit him—a slight increase of his pulse, a knotty feeling in his stomach. Even though the Soviet Union had died and the cold war was over, Michael still felt nervous every time he arrived in Russia. The truth was, “Michael Waller” would have serious problems getting through the passport check. The U.S. government had placed restrictions on his passport for travel into any country once considered communist because he had, technically, worked for the CIA in the past. His presence in a post-communist country might be taken as an act of espionage. But Michael wasn’t “Michael Waller” today.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He took a full breath into the lower lobes of his lungs. He forced his pulse to slow. His anxiety calmed quicker than usual. He wondered if the speedy calm was because he’d done this so many damn times. Then another possibility came to him. Maybe it was because of Kate. She made him feel younger, and somehow cleansed of the sins he’d committed, although she knew nothing about those sins, nor would she ever. That thought stalled him for a moment—no matter how present he was now with Kate, no matter what the future held, she could never know his past. Michael felt a wave of sadness, but he let that emotion evaporate from his body. He focused instead on how Kate made him feel—virile and youthful, yes, but more than anything optimistic, actually looking forward to his future.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The customs agent signaled to Michael. He stepped up to the man and handed him the passport he was holding. The man flipped it open and read it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sergei Kovalev?” the agent said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Da,”")])]), _vm._v(" he said. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Yes.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What countries did you visit?” the agent asked in Russian.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Italy. France.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How long were you gone?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Michael continued to answer the man’s questions in Russian, all the while giving the air of a wearied traveler eager for his trip to be over.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The agent paused then, his eyes flicking from Michael to Sergei’s passport photo.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Michael felt his breath become shallow, but he continued to give the agent a bored look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Finally, the agent lifted his head and stamped the passport with a hearty thud. “Welcome home.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thank you,” Michael said. But really, his trip had just begun.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5240c355","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodliarthe_ch05.vue
// module id = 81
// module chunks = 0